const DegradationMixin = {
  data: () => ({
    subject: 'Dégradatation',
    objetSearch: '',
    editedIndex: -1,
    editedItem: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [537700.0, 150700.0],
      },
      properties: {
        id: 0,
        title: '',
        idcategorie: null,
        icon_src: null,
        categorie: null,
        isurgent: false,
        comment: null,
        idSector: null,
        datecreated: null,
        creator: null,
        creator_name: null,
        datelastmodif: null,
        lastmodificator: null,
        isvalidated: null,
        validator: null,
        validator_name: null,
        datevalidation: null,
        isterminated: false,
        terminator: null,
        dateterminated: null,
        // isDeleted: false,
        // deletor: null,
        // dateDeleted: null,
        idaffairegoeland: null,
        geom_wkt: null,
        x: null,
        y: null,
        lon: null,
        lat: null,
      },
    },
    defaultItem: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [0.0, 0.0],
      },
      properties: {
        id: 0,
        title: '',
        idcategorie: null,
        icon_src: null,
        categorie: null,
        isurgent: false,
        comment: null,
        idSector: null,
        datecreated: null,
        creator: null,
        creator_name: null,
        datelastmodif: null,
        lastmodificator: null,
        isvalidated: null,
        validator: null,
        validator_name: null,
        datevalidation: null,
        isterminated: false,
        terminator: null,
        dateterminated: null,
        // isDeleted: false,
        // deletor: null,
        // dateDeleted: null,
        idaffairegoeland: null,
        geom_wkt: null,
        x: null,
        y: null,
        lon: null,
        lat: null,
      },
    },
  }),
};
export default DegradationMixin;
